import { useMutation } from 'react-query'
import { api } from '../../../api'

const doneTask = async (id: number) => {
  const response = await api.patch(`/tasks/${id}/done`)
  return response.data
}

export const useTaskDoneMutation = () => {
  return useMutation({
    mutationFn(id: number) {
      return doneTask(id)
    },
  })
}

const undoneTask = async (id: number) => {
  const response = await api.patch(`/tasks/${id}/undone`)
  return response.data
}

export const useTaskUndoneMutation = () => {
  return useMutation({
    mutationFn(id: number) {
      return undoneTask(id)
    },
  })
}
